import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getLocalStorageItem } from '../../utils/cookieAndLocalStorageUtils';

export const Protected = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      getLocalStorageItem('access_token') ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: '/login', state: { from: props.location } }}
        />
      )
    }
  />
);
